// src/components/InstallCTA.jsx
import React from 'react';
import chromeLogo from '../assets/chrome-logo.png';

export default function InstallCTA() {
  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <span style={styles.label}>Get started</span>
        <h2 style={styles.h2}>Make software easy to use</h2>
        <p style={styles.sub}>
          Add Shepherd to Chrome in one click and start building guides and using software with confidence.
        </p>
        <div style={styles.actions}>
            <a
              href="https://chromewebstore.google.com/detail/shepherd-build-or-follow/okjbbpkkanbhfpmmafpmijcekpjjcncl"
              target="_blank" rel="noreferrer"
              style={styles.btnPrimary}
            >
                    <img src={chromeLogo} alt="Google Chrome Logo" style={{width: "40px", height: "40px" }} />

              Install for Chrome- It's free
            </a>
          </div>
        <p style={styles.note}>Beta V1</p>
      </div>
    </section>
  );
}

const styles = {
  section: { background: 'var(--charcoal)', padding: 'clamp(4rem, 8vw, 7rem) clamp(1.5rem, 6vw, 5rem)' },
  inner: { maxWidth: 680, margin: '0 auto', textAlign: 'center' },
  label: { display: 'inline-block', fontSize: '0.78rem', fontWeight: 500, color: 'var(--brand-light)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.8rem' },
  h2: { fontFamily: "'Sora', sans-serif", fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 700, lineHeight: 1.15, color: 'white', marginBottom: '1rem' },
  sub: { fontSize: '1.05rem', color: 'rgba(255,255,255,0.55)', maxWidth: 440, margin: '0 auto 2.5rem', fontWeight: 300 },
  btn: {
    display: 'inline-flex', alignItems: 'center', gap: 10,
    background: 'var(--brand)', color: 'white',
    padding: '15px 32px', borderRadius: 'var(--radius-md)',
    fontSize: '1rem', fontWeight: 500, textDecoration: 'none',
    transition: 'background 0.2s',
  },
  note: { fontSize: '0.8rem', color: 'rgba(255,255,255,0.3)', marginTop: '1rem' },
  actions: {
    display: 'flex', 
    justifyContent: 'center', // This centers the button horizontally
    alignItems: 'center', 
    gap: '1rem',
    marginBottom: '2.5rem',
  },
  btnPrimary: {
    
    display: 'inline-flex', alignItems: 'center', gap: 8,
    background: 'var(--brand)', color: 'white',
    padding: '13px 26px', borderRadius: 'var(--radius-md)',
    fontSize: '1.15rem', fontWeight: 500,
    textDecoration: 'none', cursor: 'pointer',
    transition: 'background 0.2s, transform 0.15s',
  },
};
